import DirectionsDisplay from "./DirectionsDisplay";
import { useToolkitListStore } from "src/pods/list/toolkitListStore";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

export default function DirectionsDisplayContainer() {
  const listState = useToolkitListStore();

  return (
    <PresentationPage variant="list" onRequestHide={() => dispatchToolkitReduxAction(displayClose())}>
      <DirectionsDisplay {...listState} list={[...listState.list]} />
    </PresentationPage>
  );
}
